export const baseUrl = 'https://api.themoviedb.org/3';
export const API_KEY = '03768fc0eb2d4f4733485c16d6a585d6'
export const imageUrl = 'https://image.tmdb.org/t/p/original'